export default __webpack_public_path__ + "static/media/longchamp.d057edd5.jpg";